import {
  FoodsInput,
  CreateFoodTypes,
  FoodTable,
} from "@/types/foods";
import { ApiResponse } from "@/types";
import { apiSlice } from "@/redux/apiSlice";

export const Foods = apiSlice.injectEndpoints({
  endpoints(builder) {
    return {
      getFoods: builder.query<FoodTable, FoodsInput>({
        query: (searchCretiria) => ({
          url: `/food?org_id=${searchCretiria.org_id}&${searchCretiria.query}`,
          method: "GET",
          headers: {
            Accept: "application/json",
          },
        }),
        providesTags: ["Foods", "MealPlans"],
      }),
      createFoods: builder.mutation<ApiResponse, CreateFoodTypes>({
        query: (fooddata) => ({
          url: `/food`,
          method: "POST",
          body: fooddata,
          headers: {
            Accept: "application/json",
          },
        }),
        invalidatesTags: ["Foods","MealPlans"],
      }),
      updateFoods: builder.mutation<ApiResponse, CreateFoodTypes>({
        query: (fooddata) => ({
          url: `/food/${fooddata?.id}`,
          method: "PUT",
          body: fooddata,
          headers: {
            Accept: "application/json",
          },
        }),
        invalidatesTags: ["Foods","MealPlans"],
      }),
      deleteFoods: builder.mutation<ApiResponse, { food_id: number; org_id: number }>({
        query: (foodData) => ({
          url: `/food/${foodData.food_id}?org_id=${foodData.org_id}`,
          method: "DELETE",
          headers: {
            Accept: "application/json",
          },
        }),
        invalidatesTags: ["Foods","MealPlans"],
      }),
      getFoodById: builder.query<CreateFoodTypes, number>({
        query: (food_id) => ({
          url: `/food/${food_id}`,
          method: "GET",
          headers: {
            Accept: "application/json",
          },
        }),
        providesTags: ["Foods"],
      }),
      getFoodList: builder.query<any[], number>({
        query: (org_id) => ({
          url: `/food/list/${org_id}`,
          method: "GET",
          headers: {
            Accept: "application/json",
          },
        }),
        providesTags: ["Foods","MealPlans"],
      }),
    };
  },
});

export const {
  useGetFoodsQuery,
  useCreateFoodsMutation,
  useUpdateFoodsMutation,
  useDeleteFoodsMutation,
  useGetFoodByIdQuery,
  useGetFoodListQuery,
} = Foods;
